/* eslint-disable */
import vue from "vue";
import app from "./App.vue";


import router from "./router";
import store from "./stores";
import global from "./assets/scripts/global";
import interceptorsSetup from "./interceptors";
//import bootstrapVue from "bootstrap-vue";

//validations 
import VeeValidate from 'vee-validate';

//usado para filtres multiples en el datatable
import MultiFiltersPlugin from './plugins/MultiFilters'

// CSS
// import "bootstrap/dist/css/bootstrap.css";
// import "bootstrap-vue/dist/bootstrap-vue.css";
import "./assets/styles/sass/global.scss";
import vuetify from "@/plugins/vuetify"; // path to vuetify export
import IdleVue from 'idle-vue'
import vueCrypt from 'vue-crypt'

import JsonExcel from 'vue-json-excel'
import VueFriendlyIframe from 'vue-friendly-iframe';
vue.component('vue-friendly-iframe', VueFriendlyIframe);
vue.component('downloadExcel', JsonExcel);
var VueScrollTo = require('vue-scrollto');
vue.use(VueScrollTo)
vue.use(vueCrypt)
vue.use(MultiFiltersPlugin); 

// VUE
vue.config.productionTip = false;
vue.config.devtools = true;

vue.use(global);
// vue.use(bootstrapVue);


const eventsHub = new vue()
vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 3600000
});
vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: 'vvFields'
})

interceptorsSetup();

new vue({
  router,
  store,
  vuetify,
  render: h => h(app),
  onIdle() {
    if (localStorage.usuario !== undefined) {
      store.dispatch("usuario/clean_usuario");
      alert('Su sesión se cerrará por falta de actividad sobre la aplicación.')
      this.$router.go("/inicio");
    } else {


    }

  },
  onActive() {

  }
}).$mount("#app");